import {useCallback, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {ROUTE_PREFIX} from '../routes/new-routes';

export function useClearIncompleteBilling(redirectUrl: string) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const clearIncompleteBilling = useCallback(async () => {
    setIsLoading(true);
    const res = await fetch('/settings/team', {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-Proto': 'https',
      },
      body: JSON.stringify({
        has_incomplete_billing: false,
        _csrf: window.csrfToken ?? '',
      }),
    }).catch(() => null);

    if (res?.ok) {
      window.location.href = redirectUrl;
      return;
    }

    setIsLoading(false);
    console.error('Failed to clear incomplete billing flag', res?.status);
    navigate(`${ROUTE_PREFIX}/error`);
  }, [navigate, redirectUrl]);

  return {clearIncompleteBilling, isLoading};
}
